import { Injectable, inject } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { AppGetSupportedCountryCodes } from '../portal/app-feature.state';

@Injectable({
  providedIn: 'root',
})
export class GetPhoneCodeResolver implements Resolve<boolean> {
  constructor(private store: Store) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store.dispatch(new AppGetSupportedCountryCodes());
  }
}
